module.exports = __webpack_public_path__ + "img/全流程管理.45d79f9c.png";